module.exports = __webpack_public_path__ + "static/media/login-video.1ae08f94.mp4";